import { formatInTimeZone } from 'domains/dates/format';
import { api } from 'domains/api';
import { mapTimezoneToAPIName } from 'domains/calendars/dataNormalization';
import { AvailableTimes } from 'domains/calendars/types';
import { CompletedSignupMachineContext, SignupMachineInput } from 'domains/signup/signupFlow/signupMachine';
import { ISO_FORMAT } from 'utils/date';
import { TimeZone } from 'domains/timezone';

const POST_TIMEZONE = 'America/Phoenix';

export type ScheduleConsultationPayload = {
  cueContactID: string;
  dateTime: string;
  timeZone: string;
  appointmentType: string;
  calendarID?: string;
};

const getSchedulePayload = (
  data: {
    consultationTimezone: TimeZone;
    schedulingId: string;
    consultationDate: Date;
  } & Pick<SignupMachineInput, 'appointmentType' | 'calendarID'>,
): ScheduleConsultationPayload => {
  const timezone = mapTimezoneToAPIName(data.consultationTimezone);
  return {
    cueContactID: data.schedulingId,
    dateTime: formatInTimeZone(data.consultationDate, POST_TIMEZONE, ISO_FORMAT),
    timeZone: timezone,
    appointmentType: data.appointmentType,
    calendarID: data.calendarID,
  };
};

export const scheduleConsultationFromSignup = (
  context: CompletedSignupMachineContext,
  params: Pick<SignupMachineInput, 'appointmentType' | 'calendarID'>,
): Promise<void> => {
  return api.proxy.post(
    `/salesforce/acuity/consultation`,
    getSchedulePayload({
      consultationDate: context.scheduleInfo.consultationDate,
      consultationTimezone: context.scheduleInfo.consultationTimezone,
      schedulingId: context.leadID,
      appointmentType: params.appointmentType,
      calendarID: params.calendarID,
    }),
  );
};

export const scheduleConsultationFromSignupV2 = (data: Parameters<typeof getSchedulePayload>[0]): Promise<void> => {
  return api.proxy.post(`/salesforce/acuity/consultation`, getSchedulePayload(data));
};

export const getFirstAvailableDayIndex = (availableTimes: AvailableTimes): number | undefined => {
  const index = availableTimes.findIndex(({ availableTimes: times }) => times.length > 0);

  return index !== -1 ? index : undefined;
};
